// Global bus so any page can trigger an outgoing call via the singleton CallCenter
// mounted at the authenticated layout level.
import type { CallCenterHandle } from "./CallCenter";

let handle: CallCenterHandle | null = null;

let active = false;
let minimized = false;
const activeListeners = new Set<(v: boolean) => void>();
const minimizedListeners = new Set<(v: boolean) => void>();

export const callBus = {
  register(h: CallCenterHandle | null) { handle = h; },
  start(opts: Parameters<CallCenterHandle["start"]>[0]) {
    if (!handle) {
      console.warn("[callBus] no CallCenter registered yet");
      return;
    }
    handle.start(opts);
  },
  setActive(v: boolean) {
    if (active === v) return;
    active = v;
    activeListeners.forEach((cb) => { try { cb(v); } catch { /* noop */ } });
  },
  isActive() { return active; },
  subscribeActive(cb: (v: boolean) => void) {
    activeListeners.add(cb);
    cb(active);
    return () => { activeListeners.delete(cb); };
  },
  setMinimized(v: boolean) {
    if (minimized === v) return;
    minimized = v;
    minimizedListeners.forEach((cb) => { try { cb(v); } catch { /* noop */ } });
  },
  isMinimized() { return minimized; },
  subscribeMinimized(cb: (v: boolean) => void) {
    minimizedListeners.add(cb);
    cb(minimized);
    return () => { minimizedListeners.delete(cb); };
  },
};
